// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WGU28","content":"styles_content__224Ru","tableWrap":"styles_tableWrap__12YSE"};